import React, { useEffect, useState } from 'react';
import styles from './GamesSection.module.css';
import { appFirebase} from '../../firebase/credenciales.js';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { doc, getDoc } from 'firebase/firestore';

const db = getFirestore(appFirebase); // Inicializa Firestore


const GamesSection = () => {
  const [sorteo5M, setSorteo5M] = useState({})
  const [sorteoExpress, setSorteoExpress] = useState({})
  const [sorteoRifa, setSorteoRifa] = useState({})

  const filtrarArray = (array) => {
    return array.filter(obj => {
        // Obtener el valor del único par clave-valor en el objeto
        const valor = Object.values(obj)[0];

        // Filtrar aquellos objetos cuyo valor sea exactamente ''
        return valor === '';
    });
}
  const sorteos = () => {
    const sorteosRef = collection(db, 'sorteos'); // Referencia a la colección 'sorteos'
    const unsubscribe = onSnapshot(sorteosRef, (snapshot) => {
      const sorteosData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })); // Mapea los documentos para extraer los datos
      const cantVendido = (le)=>{return sorteosData[le].arryPuestos.length - filtrarArray(sorteosData[0].arryPuestos).length};
      setSorteo5M({
        porcentaje:(cantVendido(0) * 100)/sorteosData[0].puestos,
        data:sorteosData[0]
      })
      setSorteoExpress(sorteosData[2])
      setSorteoRifa({
        porcentaje:(cantVendido(1) * 100)/sorteosData[0].puestos,
        data:sorteosData[1]
      })

    });
    return unsubscribe; // Devuelve la función de limpieza (unsubscribe)
  };
  ;


  useEffect(()=>{
    const unsubscribeSorteo = sorteos(); // Escucha cambios en la colección de sorteos
    return () =>{
      unsubscribeSorteo && unsubscribeSorteo(); // Desuscribirse de los sorteos al desmontar el componente
    }
  },[])

  const click = ()=>{
    window.location.href = '/dashboard';
  }
  const games = [
    {
      id: 1,
      name: 'Sorteo 5M',
      jackpot: '$5.000.000',
      deadline: 'Porcentaje de progreso: ' + sorteo5M.porcentaje + '%',
      description: 'Participa en uno de los sorteos más prometedores.',
      imgSrc: sorteo5M.data?.urlImg||'https://via.placeholder.com/500x300',
    },
    {
      id: 2,
      name: 'Sorteo Express',
      jackpot: 'Premio Acumulado de: $' + sorteoExpress.premioBase ,
      deadline: 'Disponible siempre',
      description: '¡Elige tus números y gana cada hora con este juego expréss!',
      imgSrc: sorteoExpress?.urlImg||'https://via.placeholder.com/500x300',
    },
    {
      id: 3,
      name: 'Mega Rifa',
      jackpot: 'Gran premio de: ' + sorteoRifa.data?.premio,
      deadline: 'Porcentaje de progreso: ' + sorteoRifa.porcentaje + '%',
      description: 'El sorteo más grande del mes, ¡solo para los más audaces!',
      imgSrc: sorteoRifa.data?.urlImg||'https://via.placeholder.com/500x300',
    },
  ];

  return (
    <section className={styles.games}>
      <h2 className={styles.title}>Juegos y Sorteos Más Populares</h2>
      <div className={styles.cards}>
        {games.map((game) => (
          <div key={game.id} className={styles.card}>
            <div className={styles.imageWrapper}>
              <img src={game.imgSrc} alt={game.name} className={styles.image} />
            </div>
            <div className={styles.content}>
              <h3 className={styles.gameTitle}>{game.name}</h3>
              <p className={styles.jackpot}>Premio: <strong>{game.jackpot}</strong></p>
              <p className={styles.deadline}><strong>{game.deadline}</strong></p>
              <p className={styles.description}>{game.description}</p>
              <button className={styles.playNow} onClick={click}>Jugar Ahora</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GamesSection;
